import React from 'react';
import './FooterSection.scss';

const FooterSection = () => (
    <footer>© PrintLabel 2021</footer>
);

export default FooterSection;